import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '@appblocks/frontend/client/Header';

class Page404 extends Component {
    render() {
        return (
            <>
                <Header />
                <div className="container pt-5">
                    <Row>
                        <Col>
                            <h1>404 Page Not Found</h1>
                            <br />
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default Page404;
